import styled from "@emotion/styled";

import { fontRobotoCondensed, theme } from "shared/lib/styles";

type ContainerProps = {
  $isPending?: boolean;
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;

  inline-size: 100%;
  min-block-size: 100dvh;

  opacity: ${props => (props.$isPending ? 0.6 : 1)};

  transition: opacity 200ms ease;
`;

export const CardsContainer = styled.div`
  display: grid;
  grid-template-rows: min-content;
  grid-template-columns: repeat(1, 1fr);
  grid-gap: 24px 0;
  justify-items: center;

  inline-size: 100%;
  margin-block-end: 20px;

  ${theme.breakpoints.up("tablet")} {
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 32px 20px;

    margin-block-end: 32px;
  }

  ${theme.breakpoints.up("desktop")} {
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 32px 20px;

    margin-block-end: 32px;
  }

  ${theme.breakpoints.up("mediumDesktop")} {
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 32px 20px;

    margin-block-end: 32px;
  }
`;

export const LoadMoreButton = styled.button`
  inline-size: 270px;
  block-size: 43px;
  margin-inline: auto;
  padding-block: 12px;

  color: #ffffff;
  font-weight: 700;
  font-size: 16px;
  font-family: ${fontRobotoCondensed};
  text-transform: uppercase;

  border-radius: 4px;

  background-color: #2c4692;

  cursor: pointer;
`;
